module.exports = __webpack_public_path__ + "img/text-main.8731225.svg";